import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '../ui/tooltip';
import clsx from 'clsx';
import toastifyInstance from '../../utils/toastify';
import React, { useState } from 'react';

interface HoverTextProps {
    text: any;
    visible?: boolean;
    truncatedTextProp?: any;
    countShow?: number;
    children?: React.ReactNode;
}

const HoverText = React.memo(({ text, visible = false, truncatedTextProp, countShow = 10, children }: HoverTextProps) => {
    const truncatedText = truncatedTextProp || text?.length > countShow ? text.substring(0, countShow) + "..." : text;
    const [hover, setHover] = useState(false);

    const handleCopy = () => {
        if (visible) return;
        navigator.clipboard.writeText(text);
        toastifyInstance.success('copied successfully', { autoClose: 1000 });
    }

    if (text === null || text === undefined || text === '') {
        return <span className='text-gray-500 text-center w-full'>-</span>
    }

    if (typeof text === 'boolean') {
        return <span className='text-gray-500 text-center w-full'>{text ? 'true' : 'false'}</span>
    }


    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className={clsx("cursor-pointer", hover && !visible && "text-blue-500")}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onClick={handleCopy}
                    >
                        {truncatedText}
                    </span>
                </TooltipTrigger>
                {
                    !visible &&
                    <TooltipContent className={clsx('bg-white')}>
                        {text}
                    </TooltipContent>
                }
                {children && children}
            </Tooltip>
        </TooltipProvider>
    );
});

export default HoverText;